"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureSlash = exports.collectDependencies = exports.constructElement = void 0;
function constructElement(providers, element) {
    return Object.keys(providers).reduce((children, key) => {
        return providers[key].component(children);
    }, element);
}
exports.constructElement = constructElement;
function collectDependencies(providers) {
    return Object.keys(providers).reduce((dependencies, key) => {
        dependencies[key] = providers[key].provider;
        return dependencies;
    }, {});
}
exports.collectDependencies = collectDependencies;
function ensureSlash(path) {
    return path.endsWith("/") ? path : path + "/";
}
exports.ensureSlash = ensureSlash;
//# sourceMappingURL=helpers.js.map